export default __webpack_public_path__ + "static/media/Group 203.9f4df524.svg";